module.exports = __webpack_public_path__ + "static/img_9795-69e0eb0426ca9741570153c9d84e3b38.webp";